
import { Watch, Mixins, Component, InjectReactive } from "vue-property-decorator";
import TablePagination from "@/mixins/tablePagination";
import Resize from "@/mixins/resize";

import ETable from "@/components/ETable.vue";

// import AddDialog from "./add.vue"; 

import { fdmMedicinalList, fdmMedicinalListStatus } from "@/api/consultation";
import { GenderEnum2 } from "@/enum/symptoms.enum";
import { StatusEnum } from "@/enum/common.enum";

import Add from "./ProductDialog.vue";

import { cloneDeep } from "lodash";

@Component({ name: 'fourCombine-components-fourMedicine',
    components: {
        ETable, Add
    }
})
export default class FourMedicine extends Mixins(TablePagination, Resize) {
    @InjectReactive() currentTab!: string|number;
    @InjectReactive() merchantId!: string|number;

    queryForm = {
        productName: ""
    }

    columns = [
        { label: "ID", prop: "id" },
        { label: "产品名称", prop: "productName" },
        { label: "功效", prop: "effect" },
        { label: "状态", formatter: (row) => StatusEnum[row.status] },
        { label: "操作", prop: "action" },
    ];

    tableData = [];
    itemTotal = 0;

    loading = false

    addDialogVisible = false;
    editData = {};
    

    mounted() {
        this.windowResize(350);
    }

    handleStatusChange(row) {
        fdmMedicinalListStatus({ fragranceId: row.id, status: Number(!row.status) }).then(() => {
            this.getData();
        })
    }


    fdmMedicinalList() {
        const params = {
            ...this.queryForm,
            pageSize: this.pageSize,
            pageNum: this.currentPage,
        }
        this.loading = true;
        fdmMedicinalList(params).then((res) => {
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
        }).finally(() => {
            this.loading = false;
        })
    }

    @Watch("currentTab", { immediate: true })
    getData() {
        if (this.currentTab != 2) return;
        this.fdmMedicinalList();
    }

    //重置分页参数
    resetPages() {
      this.currentPage = 1;
    }

    handleSearch() {
        this.resetPages();
        this.getData();
    }

    handleEdit(row = { status: 1 }) {
        this.addDialogVisible = true;
        this.editData = cloneDeep(row);
    }
}
